import { render, staticRenderFns } from "./comp_CheckoutStep-recetadigital--active.vue?vue&type=template&id=0aa9e268&scoped=true&"
import script from "./comp_CheckoutStep-recetadigital--active.vue?vue&type=script&lang=js&"
export * from "./comp_CheckoutStep-recetadigital--active.vue?vue&type=script&lang=js&"
import style0 from "./comp_CheckoutStep-recetadigital--active.vue?vue&type=style&index=0&id=0aa9e268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa9e268",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VProgressCircular,VSpacer})
